import React, { Component } from "react";
import { Form } from 'semantic-ui-react';
import  Logo  from "./logo";
import trocaSenhaImg from "../img/esqueci-minha-senha-topo.png";
import { isUndefined } from "util";
import formatError from "../js/formatError"
import apiEsqueciSenha from "../core/apiEsqueciSenha";

class EnvioSms extends Component {
  constructor(props){
    super(props);
    this.state = {
      codigoSms: "",
      usuario: isUndefined(this.props.history.location.state)?null:this.props.history.location.state.usuario,
      resultsMessage:"",
      error: isUndefined(this.props.history.location.state) || isUndefined(this.props.history.location.state.passo)?"Você deve passar por todo o fluxo de Esqueci Minha Senha.":"",
      passo: isUndefined(this.props.history.location.state)?false:!isUndefined(this.props.history.location.state.passo),
      mensagemSmsEnviado: isUndefined(this.props.history.location.state)?null:this.props.history.location.state.mensagemSmsEnviado,
      mensagemSucesso:"",
      loadingReenviar: false,
      loadingValidar: false,
    };

  }

  handleCancelar = async e => {
    e.persist();
    if(window.confirm("Atenção: Tem certeza que deseja cancelar o processo de Esqueci Minha Senha?")) {
      this.props.history.push("/resetPassword");
    }
  }


  handleReenviarSms = async e => {
    this.setState({ 
      resultsMessage:"",
      error:"",
      mensagemSmsEnviado:"",
      codigoSms: "",
      loadingReenviar: true
    });
    e.persist();
    try {
      await apiEsqueciSenha.post("/reenviarSms?userName="+this.state.usuario)
        .then(res => {
            this.setState({
              mensagemSmsEnviado: res.data,
              error:"",
              resultsMessage:""
            });
          }
        );

    } catch(err) {
      if(err.message ==='Request failed with status code 400'){
        this.setState({
          resultsMessage: err.response.data,
          error:"",
          mensagemSmsEnviado:""
        });
      }else{
        formatError(err.response, this);
      }
    }
    this.setState({loadingReenviar: false });
  }


  handleValidarSms = async e => {
    this.setState({
      resultsMessage:"",
      error:"",
      mensagemSmsEnviado:"",
      loadingValidar: true
     });
    e.persist();
    try {
      await apiEsqueciSenha.post("/validarSms?userName="+this.state.usuario+"&token="+this.state.codigoSms)
        .then(res => {
            this.setState({
              mensagemSucesso: res.data,
              error:"",
              resultsMessage:""
            });
          }
        );

        if(this.state.mensagemSucesso){
          this.props.history.push("/resetPasswordSucess",{passo:3, mensagemSucesso: this.state.mensagemSucesso});
        } 

    } catch(err) {
      if(err.message ==='Request failed with status code 400'){
        this.setState({
          resultsMessage: err.response.data,
          error:"",
          mensagemSucesso:"",
          mensagemSmsEnviado:""
        });
      }else{
        this.setState({
          resultsMessage: "",
          mensagemSmsEnviado:"",
          mensagemSucesso:"",
        });
        formatError(err.response, this);
      }
    }
    this.setState({ loadingValidar: false });
  }

  render() {
    const { loadingReenviar } = this.state;
    const { loadingValidar } = this.state;
    if(!this.state.passo) {
      this.props.history.push("/resetPassword");
    }
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <h5 className="card-title text-center margin-top">
              <img src={trocaSenhaImg} className="img-responsive troca-senha" alt="Confirmação de Dados" />
            </h5>
            <Form  onSubmit={this.handleValidarSms} autoComplete="off">
            {this.state.error && <div className="msgError center">{this.state.error}</div>}
            {this.state.resultsMessage && <div className="msgWarning center">{this.state.resultsMessage}</div>}
            <br/><p>{this.state.mensagemSmsEnviado}</p> 
              <input 
               type="text" pattern="[0-9]*"
                id="codigoSms"
                className="form-control margin-button-input bkg-verde" 
                placeholder="Informe o código recebido via SMS" 
                maxLength="6"
                disabled={this.state.mensagemSmsEnviado ==="" && this.state.usuario ===""}
                onChange={e => this.setState({ codigoSms: e.target.value.replace(/\D/,'')})} 
                value={this.state.codigoSms}
                />
                
               <button id="btnValidar" 
                       className="btn btn-primary btn-block margin-top-input text-uppercase" 
                       type="submit" 
                       disabled={this.state.codigoSms ==="" || loadingValidar || loadingReenviar}
                      >  {loadingValidar ? 'CARREGANDO...' : 'Validar'} 
              </button>

              <button id="btnReenviarSms" 
                      className="btn btn-primary btn-block margin-top-input text-uppercase" 
                      type="button" 
                      disabled={(this.state.mensagemSmsEnviado ==="" && this.state.usuario ==="" ) || loadingValidar || loadingReenviar}
                      onClick={this.handleReenviarSms}
                      > 
                      {loadingReenviar ? 'CARREGANDO...' : 'Reenviar SMS'} 
              </button>
              <button id="btnCancelar"  disabled={loadingValidar || loadingReenviar} className="btn btn-secondary btn-block text-uppercase" type="button" onClick={this.handleCancelar}>CANCELAR</button>
              <Logo />
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default EnvioSms;
